import React, { useEffect, useMemo, useState } from 'react'
import { Table, FormInput, Row, Button, Widget, ColumnProps, FormSelect } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import ptBR from '@app/i18n/ptBR'
import { orcadoAnoParametroState, solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { useRecoilValue } from 'recoil';
import { OrcamentoSolicitacaoNaoPrevisto, getOrcamentoSolicitacaoNaoPrevisto, createOrcamentoSolicitacaoNaoPrevisto, updateOrcamentoSolicitacaoNaoPrevisto, deleteOrcamentoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import { currencyFormatSemAbreviacao } from '@app/helpers/numbers';
import { EStatusSolicitacaoNaoPrevisto, ETipoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { Visibility } from '@app/components/Visibility';


const { Panel } = Collapse;
const Orcamento = ({ list, setList, orcamentos, setOrcamentos, acronimos, contasContabil }: any) => {
  const idSolicitacao = useRecoilValue(solicitacaoIdState);
  const solicitacao = useRecoilValue(solicitacaoState);
  const orcadoAnoNaoPrevisto = useRecoilValue(orcadoAnoParametroState);

  const onSelectSigla = (item: OrcamentoSolicitacaoNaoPrevisto, value: string) => {
    item.sigla = value
    let acronimosTemp = [...acronimos]
    acronimosTemp = acronimosTemp.filter((acronimo) => acronimo.sigla === value)

    if (acronimosTemp.length === 0) {
      item.disciplina = undefined
      item.tipo = undefined
    }

    if (acronimosTemp.length === 1) {
      item.sigla = acronimosTemp[0].sigla
      item.disciplina = acronimosTemp[0].disciplinaNome
      item.tipo = acronimosTemp[0].tipoNome
    }

    handleEdit(item)
  }

  const onSelectDisciplina = (item: OrcamentoSolicitacaoNaoPrevisto, value: string) => {
    item.disciplina = value
    let acronimosTemp = [...acronimos]
    acronimosTemp = acronimosTemp.filter((acronimo) => acronimo.disciplinaNome === value)

    if (item.tipo !== undefined)
      acronimosTemp = acronimosTemp.filter((acronimo) => acronimo.tipoNome === item.tipo)

    if (acronimosTemp.length === 0) {
      item.tipo = undefined
      item.sigla = undefined
    }

    if (acronimosTemp.length === 1) {
      item.sigla = acronimosTemp[0].sigla
      item.disciplina = acronimosTemp[0].disciplinaNome
      item.tipo = acronimosTemp[0].tipoNome
    }

    handleEdit(item)
  }

  const onSelectTipo = (item: OrcamentoSolicitacaoNaoPrevisto, value: string) => {
    item.tipo = value
    let acronimosTemp = [...acronimos]
    acronimosTemp = acronimosTemp.filter((acronimo) => acronimo.tipoNome === item.tipo)

    if (item.disciplina !== undefined)
      acronimosTemp = acronimosTemp.filter((acronimo) => acronimo.disciplinaNome === item.disciplina)

    if (acronimosTemp.length === 0) {
      item.disciplina = undefined
      item.sigla = undefined
    }

    if (acronimosTemp.length === 1) {
      item.sigla = acronimosTemp[0].sigla
      item.disciplina = acronimosTemp[0].disciplinaNome
      item.tipo = acronimosTemp[0].tipoNome
    }

    handleEdit(item)
  }

  const onSelectContaContabil = (item: OrcamentoSolicitacaoNaoPrevisto, value: string) => {
    item.contaContabil = value
    let contasTemp = [...contasContabil]
    contasTemp = contasTemp.filter((conta) => conta.codigo === value)


    if (contasTemp.length === 0) {
      item.agrupador = undefined
    }

    if (contasTemp.length === 1) {
      item.agrupador = contasTemp[0].codigoAgrupador
    }

    handleEdit(item)
  }

  const handleChangeDescricaoPacote = (item: OrcamentoSolicitacaoNaoPrevisto, value: string) => {
    const newList = list.map((i) => {
      if (i.id === item.id) {
        i.descricaoPacote = value
      }
      return i
    })

    setList(newList)
  }

  const getLista = () => {
    if (idSolicitacao === undefined) return
    getOrcamentoSolicitacaoNaoPrevisto(idSolicitacao).then((response) => {
      if (response) {
        const newOrcamentoList = response.map((item) => {
          return { ...item }
        })
        setList([...response])
        setOrcamentos(newOrcamentoList)
      }
    })
  }

  const handleEdit = (item: any) => {
    const itemDefault = orcamentos.find((i) => i.id === item.id)
    if (itemDefault === undefined) return
    if (JSON.stringify(itemDefault) === JSON.stringify(item)) return

    updateOrcamentoSolicitacaoNaoPrevisto(item).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const handleAdd = () => {
    if (idSolicitacao === undefined) return

    createOrcamentoSolicitacaoNaoPrevisto({ solicitacaoNaoPrevistoId: idSolicitacao }).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const handleRemove = (id: string) => {
    deleteOrcamentoSolicitacaoNaoPrevisto(id).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const creatTitleCalculado = (totalEmReais?: number) => {
    if (totalEmReais) {
      return <span>{ptBR.lblTotalReais}: {currencyFormatSemAbreviacao(totalEmReais)} <br></br> {ptBR.lblTotalDolar}: {currencyFormatSemAbreviacao(totalEmReais / (orcadoAnoNaoPrevisto.valorDolar ?? 0))} </span>
      return `${ptBR.lblTotalReais}: ${totalEmReais}`
    }

    return ``
  }

  const columnsMeses: ColumnProps<any>[] = [
    {
      title: `${ptBR.lblJaneiro}`,
      dataIndex: 'janeiro',
      children: [
        {
          // title: creatTitleCalculado(100),
          title: creatTitleCalculado(list.reduce((n, { janeiro }) => n + (janeiro || 0), 0)),
          dataIndex: 'janeiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`janeiro`}
                span={12}
                value={record.janeiro}
                onChange={e => record.janeiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ],
    },
    {
      title: `${ptBR.lblFevereiro}`,
      dataIndex: 'fevereiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { fevereiro }) => n + (fevereiro || 0), 0)),
          dataIndex: 'fevereiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`fevereiro`}
                span={12}
                value={record.fevereiro}
                onChange={e => record.fevereiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblMarco}`,
      dataIndex: 'marco',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { marco }) => n + (marco || 0), 0)),
          dataIndex: 'marco',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`marco`}
                span={12}
                value={record.marco}
                onChange={e => record.marco = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblAbril}`,
      dataIndex: 'abril',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { abril }) => n + (abril || 0), 0)),
          dataIndex: 'abril',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`abril`}
                span={12}
                value={record.abril}
                onChange={e => record.abril = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblMaio}`,
      dataIndex: 'maio',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { maio }) => n + (maio || 0), 0)),
          dataIndex: 'maio',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`maio`}
                span={12}
                value={record.maio}
                onChange={e => record.maio = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblJunho}`,
      dataIndex: 'junho',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { junho }) => n + (junho || 0), 0)),
          dataIndex: 'junho',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`junho`}
                span={12}
                value={record.junho}
                onChange={e => record.junho = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblJulho}`,
      dataIndex: 'julho',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { julho }) => n + (julho || 0), 0)),
          dataIndex: 'julho',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`julho`}
                span={12}
                value={record.julho}
                onChange={e => record.julho = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblAgosto}`,
      dataIndex: 'agosto',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { agosto }) => n + (agosto || 0), 0)),
          dataIndex: 'agosto',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`agosto`}
                span={12}
                value={record.agosto}
                onChange={e => record.agosto = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblSetembro}`,
      dataIndex: 'setembro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { setembro }) => n + (setembro || 0), 0)),
          dataIndex: 'setembro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`setembro`}
                span={12}
                value={record.setembro}
                onChange={e => record.setembro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblOutubro}`,
      dataIndex: 'outubro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { outubro }) => n + (outubro || 0), 0)),
          dataIndex: 'outubro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`outubro`}
                span={12}
                value={record.outubro}
                onChange={e => record.outubro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblNovembro}`,
      dataIndex: 'novembro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { novembro }) => n + (novembro || 0), 0)),
          dataIndex: 'novembro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`novembro`}
                span={12}
                value={record.novembro}
                onChange={e => record.novembro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblDezembro}`,
      dataIndex: 'dezembro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { dezembro }) => n + (dezembro || 0), 0)),
          dataIndex: 'dezembro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`dezembro`}
                span={12}
                value={record.dezembro}
                onChange={e => record.dezembro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblTotal}`,
      dataIndex: 'total',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { total }) => n + (total || 0), 0)),
          dataIndex: 'totalFormatado',
          width: '10%',
        },
      ]
    }
  ]

  const columns = useMemo(() => {
    const collumns: ColumnProps<any>[] = []

    if (solicitacao === undefined) return collumns

    collumns.push({
      title: 'N',
      dataIndex: 'index',
    })

    if (solicitacao.tipo.toUpperCase() === ETipoNaoPrevisto.CNP.toUpperCase()) {
      collumns.push(
        {
          title: `${ptBR.lblSigla}`,
          width: '150px',
          render(text, record, index) {
            //unique sigla
            let siglas = acronimos.flatMap((item) => item.sigla)
            siglas = [...new Set(siglas)]
            return (
              <FormSelect
                name='sigla'
                span={12}
                value={record.sigla}
                onChange={e => onSelectSigla(record, e)}
                options={siglas.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblDisciplina}`,
          width: '150px',
          render(text, record, index) {
            let acronimosTemp = [...acronimos]

            if (record.sigla !== undefined && record.sigla !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.sigla === record.sigla)
            else if (record.tipo !== undefined && record.tipo !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.tipoNome === record.tipo)

            let disciplinas = acronimosTemp.flatMap((item) => item.disciplinaNome)
            disciplinas = [...new Set(disciplinas)]
            disciplinas = disciplinas.sort()
            return (
              <FormSelect
                name='disciplina'
                span={12}
                value={record.disciplina}
                onChange={e => onSelectDisciplina(record, e)}
                options={disciplinas.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblTipo}`,
          width: '150px',
          render(text, record, index) {
            let acronimosTemp = [...acronimos]

            if (record.sigla !== undefined && record.sigla !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.sigla === record.sigla)
            else if (record.disciplina !== undefined && record.disciplina !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.disciplinaNome === record.disciplina)

            //unique tipo
            let tipos = acronimosTemp.flatMap((item) => item.tipoNome)
            tipos = [...new Set(tipos)]

            return (
              <FormSelect
                name='tipo'
                span={12}
                value={record.tipo}
                onChange={e => onSelectTipo(record, e)}
                options={tipos.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        }
      )

      // collumns.push(
      //   {
      //     title: `${ptBR.lblPacoteTipoEDisciplina}`,
      //     dataIndex: 'pacote',
      //     width: '100px',
      //     render(text, record, index) {
      //       return (
      //         <FormInput
      //           span={12}
      //           name={`pacote`}
      //           value={record.pacote}
      //           disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
      //         />
      //       )
      //     },
      //   }
      // )
    }

    if (solicitacao.tipo.toUpperCase() === ETipoNaoPrevisto.ONP.toUpperCase()) {
      collumns.push(
        {
          title: `Natureza`,
          width: '150px',
          render(text, record, index) {
            //unique contas
            let contas = contasContabil.flatMap((item) => item.codigo)
            contas = [...new Set(contas)]

            return (
              <FormSelect
                name='contaContabil'
                span={12}
                value={record.contaContabil}
                onChange={e => onSelectContaContabil(record, e)}
                options={contas.map((item) => ({ text: item, value: item }))}
                filterOption={(input, item) => {
                  return item.props.children.props.id
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                showSearch
                allowClear
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblAgrupador}`,
          width: '150px',
          render(text, record, index) {
            return (
              <FormInput
                span={12}
                name={`agrupador`}
                value={record.agrupador}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        }
      )
    }

    collumns.push(
      {
        title: `${ptBR.lblDescricaoDoPacote}`,
        dataIndex: 'descricaoPacote',
        width: '300px',
        render(text, record, index) {
          return (
            <FormInput
              span={12}
              name={`descricaoPacote`}
              value={record.descricaoPacote}
              onChange={e => handleChangeDescricaoPacote(record, e.target.value)}
              onBlur={() => handleEdit(record)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleEdit(record)
                }
              }}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          )
        },
      }
    )

    collumns.push(...columnsMeses)

    collumns.push(
      {
        title: `${ptBR.lblAcao}`,
        dataIndex: 'acao',
        fixed: 'right',
        render(text, record, index) {
          return (
            <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} >
              <Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                icon='science-minus'
                onClick={() => handleRemove(record.id)} />
            </Visibility>
          )
        }
      }
    )

    return collumns
  }, [solicitacao, acronimos, contasContabil, list, orcamentos])

  return (

    <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="2" header={ptBR.lblOrcamento} style={{ border: 0 }}>
        <Widget
          title=""
          actions={[]}>
          <Row>
            <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} >
              <Button style={{ float: 'inline-end' }} icon='commons-plus' type='link' onClick={handleAdd} />
            </Visibility>
          </Row>
          <Row>
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              pagination={false}
            />
          </Row>
        </Widget>
      </Panel>
    </Collapse>


  )
}

export default Orcamento